import { IonIcon } from '@ionic/react'
import { ParseKeys } from 'i18next'
import { addOutline, checkmarkOutline } from 'ionicons/icons'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme'
import { MessageError } from './styled'

type ButtonFieldProps = {
  children?: ReactNode
  errorMessage?: ParseKeys
  onClick?: () => void
  isLoading?: boolean
  isCheck?: boolean
  dataTestId?: string
}

export function ButtonField({
  children,
  errorMessage,
  onClick,
  isLoading,
  isCheck,
  dataTestId,
}: ButtonFieldProps) {
  const { t } = useTranslation()
  return (
    <div data-testid={dataTestId}>
      <Button
        variant='whiteBorder'
        fullWidth
        uppercase
        loading={isLoading}
        onClick={onClick}
        endDecorator={
          <IonIcon
            style={{
              fontSize: '16px',
              '--ionicon-stroke-width': '52px',
              color: isCheck ? myPalette.green.main : myPalette.black.main,
            }}
            icon={isCheck ? checkmarkOutline : addOutline}
          />
        }
      >
        {children}
      </Button>

      {errorMessage && (
        <MessageError data-testid='error-message'>
          {t(errorMessage) as string}
        </MessageError>
      )}
    </div>
  )
}
